import React from "react";
import "./HowDoesItWorks.css";
import Carousel from "../Carousel/Carousel";
import ImgCarousel from "../ImgCarousel/ImgCarousel";

const HowDoesItWorks = () => {
  return (
    <div className="howdoesitworks">
      <h2>How does it work?</h2>
      <p>
        Unlocking the magic of connection, our algorithm dances through hearts, weaving destinies with precision. Every click, every swipe, a step closer to serendipity. Love's symphony orchestrated flawlessly, as souls find their perfect harmony in the tapestry of fate.
      </p>
      <ImgCarousel />
    </div>
  );
};

export default HowDoesItWorks;
